import config from '../config';

const appConfig = config();
const { v2 } = appConfig.apiVersion;
const { apiPrefix } = appConfig;

export default class NotificationRuleService {
  constructor(client) {
    this.client = client;
  }

  async getCompanyNotificationRules({ companyId, companyNotificationTypeId }) {
    const response = await this.client.get(
      `${apiPrefix}${v2}/companies/${companyId}/notification-rules`,
      { params: { companyNotificationTypeId } }
    );
    return response.data;
  }

  async getCompanyNotificationTypes() {
    const response = await this.client.get(
      `${apiPrefix}${v2}/company-notification-types`
    );
    return response.data;
  }

  async createCompanyNotificationRule({
    companyId,
    companyNotificationTypeId,
    groupCompanyId,
    policyId,
    emails
  }) {
    const response = await this.client.post(
      `${apiPrefix}${v2}/companies/${companyId}/notification-rules`,
      {
        companyNotificationTypeId,
        groupCompanyId,
        policyId,
        emails
      }
    );
    return response.data;
  }

  async updateCompanyNotificationRule({
    id,
    companyId,
    companyNotificationTypeId,
    groupCompanyId,
    policyId,
    emails
  }) {
    const response = await this.client.patch(
      `${apiPrefix}${v2}/companies/${companyId}/notification-rules/${id}`,
      {
        ...(companyNotificationTypeId ? { companyNotificationTypeId } : {}),
        ...(groupCompanyId ? { groupCompanyId } : {}),
        ...(policyId ? { policyId } : {}),
        emails
      }
    );
    return response.data;
  }

  async deleteCompanyNotificationRule({ id, companyId }) {
    const response = await this.client.delete(
      `${apiPrefix}${v2}/companies/${companyId}/notification-rules/${id}`
    );
    return response.data;
  }
}
